var map = {
	"./blibli-info-adding-store.webp": "e3f3",
	"./blibli.svg": "dc9e",
	"./lazada.svg": "c1ad",
	"./shopee.svg": "f3ca9",
	"./success-add.svg": "043d",
	"./tiktok-shop-tokopedia.webp": "34f1",
	"./tiktok.svg": "63f9",
	"./toco.svg": "a228",
	"./tokopedia.svg": "8781",
	"./zalora.svg": "8b9b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "690e";